import { action } from 'satcheljs/lib/legacy';
import FilePickerFilterOptionsState from '../store/schema/FilePickerFilterOptionsState';

export default action('setShowFilterOptions')(function setShowFilterOptions(
    optionsState: FilePickerFilterOptionsState,
    newValue: boolean
) {
    optionsState.showFilterOptions = newValue;
});
